export default {
  btnName: 'Profile',
  options: {
    info: 'Profile',
    trips: 'My Trips',
    logout: 'Logout',
  },
};
